import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Text,
  Box,
  Button,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { RotateCw, ArrowLeft } from "lucide-react";
import { useState } from "react";
import dayjs from "dayjs";

const SprintPopover = ({ sprintList, roleId }) => {
  
  const [selectedSprint, setSelectedSprint] = useState(null);

  const calculateDaysLeft = (endDate) => {
  if (!endDate) return "--";

  const end = dayjs(endDate).startOf("day");
  const today = dayjs().startOf("day");

  return end.diff(today, "day");
};


 

  return (
    <Popover placement="bottom-start">
      <PopoverTrigger>
        <IconButton
          aria-label="Redo sprint"
          icon={<RotateCw size={16} />}
          size="sm"
          variant="outline"
          colorScheme="purple"
        />
      </PopoverTrigger>

      <PopoverContent w="260px">
        <PopoverBody>
          {/* ---------- ACTIVE SPRINT LIST ---------- */}
          {!selectedSprint && (
            <VStack align="stretch" spacing={2}>
              <Text fontWeight="600" fontSize="sm">
                Active Sprints
              </Text>

              {sprintList?.length > 0 ? (
                sprintList?.map((sprint) => (
                  <Box
  key={sprint.sprint_id}
  px={2}              // horizontal padding
  py={1} 
  pt={4}             // small vertical padding
  h="26px"          // compact height
  display="flex"
  alignItems="center"
  border="1px solid #E2E8F0"
  borderRadius="sm"
  cursor="pointer"
  _hover={{ bg: "gray.50" }}
  onClick={() => setSelectedSprint(sprint)}
>
  <Text
    fontSize="sm"
    fontWeight="500"
    color="blue.500"            // link color
    _hover={{
      textDecoration: "underline",
      color: "blue.600",
    }}
  >
    {sprint.sprint_name}
  </Text>
</Box>

                ))
              ) : (
                <Text fontSize="sm" color="gray.500">
                  No active sprints
                </Text>
              )}
            </VStack>
          )}

          {/* ---------- SPRINT DETAILS ---------- */}
        {selectedSprint && (
  <Box
    border="1px solid #E2E8F0"
    borderRadius="md"
    p={3}
    bg="white"
  >
    {/* Header */}
    <HStack mb={1} spacing={2}>
      <IconButton
        size="xs"
        variant="ghost"
        icon={<ArrowLeft size={14} />}
        onClick={() => setSelectedSprint(null)}
      />
      <Text fontWeight="600" fontSize="sm">
        {selectedSprint.sprint_name}
      </Text>
    </HStack>

    {/* Days left */}
    <Text fontSize="sm" color="gray.500" mb={3}>
      {calculateDaysLeft(selectedSprint.end_date)} days left
    </Text>

    {/* Dates row */}
    <HStack spacing={6}>
      <Box>
        <Text fontSize="xs" color="gray.500">
          Start date
        </Text>
        <Text fontSize="sm" fontWeight="500">
          {selectedSprint.start_date
            ? dayjs(selectedSprint.start_date).format("MMM D, YYYY")
            : "--"}
        </Text>
      </Box>

      <Box>
        <Text fontSize="xs" color="gray.500">
          End date
        </Text>
        <Text fontSize="sm" fontWeight="500">
          {selectedSprint.end_date
            ? dayjs(selectedSprint.end_date).format("MMM D, YYYY")
            : "--"}
        </Text>
      </Box>
    </HStack>
  </Box>
)}

        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default SprintPopover;
